import { api } from '../lib/api';

export interface HoneyroomBatch {
  containerId: number;
  containerCode: string;
  productId: number;
  productName: string;
  remainingKg: number;
  siteId: number;
  siteName: string;
}

export interface HoneyroomDevice {
  id: number;
  siteId: number;
  siteName: string;
  deviceKey: string;
  name: string;
  deviceType: string;
  model: string | null;
  shape: 'tank' | 'creamer' | 'cabinet';
  sortOrder: number;
  capacityLiters: number | null;
  supportsTemperature: boolean;
  supportsHumidity: boolean;
  supportsHeater: boolean;
  supportsMixer: boolean;
  supportsPower: boolean;
  productSummary: string | null;
  totalKg: number;
  batches: HoneyroomBatch[];
  metrics: {
    temperatureC: number | null;
    humidityPct: number | null;
    heaterOn: boolean | null;
    mixerOn: boolean | null;
    powerW: number | null;
    latestObservedAt: string | null;
  };
}

export interface HoneyroomOverview {
  room: {
    roomKey: string;
    inventorySiteId: number | null;
    inventorySiteName: string | null;
    sensorKeyConfigured: boolean;
    sensorBusinessIdConfigured: boolean;
    supportedMetrics: string[];
  };
  devices: HoneyroomDevice[];
  eligibleSites: Array<{
    siteId: number;
    name: string;
    type: 'lager' | 'maskin';
    deviceKey: string | null;
  }>;
  movableContainers: HoneyroomBatch[];
}

export const honeyroomApi = {
  overview: () => api.get<HoneyroomOverview>('/honeyroom/overview'),
  setupDefault: () => api.post<{ ok: boolean }>('/honeyroom/setup-default'),
  moveContainer: (payload: { containerId: number; targetSiteId: number }) =>
    api.post<{ ok: boolean; txId: number }>('/honeyroom/move', payload),
};
